import React, { ReactNode } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import { MapViewContainer } from './styled/view-container';

interface IMapContainer extends IBaseProps {
  map: ReactNode;
  hide: boolean;
}

/*
 * NOTE: We want to only render the map once
 * So we "hide" / `display: none` the map container when on the list view
 */
export const MapContainer = ({ children, map, hide }: IMapContainer) => {
  // We need to track when we have shown the map already so we don't load it again
  const [hasBeenMounted, setHasBeenMounted] = React.useState(!hide);
  if (!hasBeenMounted && hide) {
    return null;
  }
  return (
    <MapViewContainer ref={() => setHasBeenMounted(true)} hide={hide}>
      {map}
      {children}
    </MapViewContainer>
  );
};
